<h2 mat-dialog-title>Verplaatsen</h2>

<mat-dialog-content class="flex! flex-col">
    <div class="mb-2">
        <p>Selecteer de unit waar het apparaat naartoe moet worden verplaatst.</p>
    </div>
    <mat-form-field appearance="fill">
        <mat-label>Units</mat-label>
        <mat-select [(value)]="selectedUnit">
            @for (unit of data.units; track unit._id) {
                <mat-option [value]="unit" [disabled]="isUnitSelectable(unit)">{{ unit.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

    <button mat-button (click)="handleConfirm()" [disabled]="submitted() || !selectedUnit">
        <mat-spinner class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out" [diameter]="16"
            [class.opacity-100]="loading()" [class.opacity-0]="!loading()"></mat-spinner>

        <span [class.opacity-0]="loading()" class="transition-opacity">Verplaatsen</span>
    </button>
</mat-dialog-actions>